import { formatDate } from "@/core/filters";
import { Contact } from "@/model/contact.model";
import { FamilyMember } from "@/model/member.model";

export const memberItem = (member: FamilyMember): string => {
  return `${member.first} ${member.last} (${formatDate(member.birth)})`
}

export const contactName = (contact: Contact): string => {
  return contact.name ? contact.name : '[Onbekend]'
}

export const contactInfo = (contact: Contact): string => {
  return contact.email && contact.phone
    ? `(${contact.email} - ${contact.phone})`
    : contact.email
      ? `(${contact.email})`
      : contact.phone ? `(${contact.phone})` : '';
}
